import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';
import Label from 'components/atoms/label/index.jsx';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class RadioButtonGroup extends Component {
  render() {
    let className = cx({
      radioButtonGroup: true,
      list: this.props.list,
      compact: this.props.compact,
    });

    //Title
    let radioButtonGroupTitle;
    if (this.props.title) {
      radioButtonGroupTitle = <Label label={this.props.title} />;
    }

    return (
      <div className={classnames(className)}>
        {radioButtonGroupTitle}
        {this.props.children}
      </div>
    );
  }
}
